import React, { useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { requestAPI } from '../../data/api'
import './ViolationOverview.css'

const DEBOUNCE_MS = 200

const ViolationOverview = ({ history }) => {
	const [query, setQuery] = useState('')
	const [results, setResults] = useState([])
	const [loading, setLoading] = useState(false)
	const [hasSearched, setHasSearched] = useState(false)
	const requestSeq = useRef(0)

	useEffect(() => {
		const trimmed = query.trim()
		if (trimmed.length < 2) {
			setResults([])
			setLoading(false)
			setHasSearched(false)
			return undefined
		}

		const seq = ++requestSeq.current
		setLoading(true)
		const timer = setTimeout(async () => {
			try {
				const data = await requestAPI(
					`/violations/search?q=${encodeURIComponent(trimmed)}`,
					'GET',
				)
				if (seq !== requestSeq.current) return
				setResults(Array.isArray(data) ? data : [])
				setHasSearched(true)
			} catch (e) {
				if (seq !== requestSeq.current) return
				setResults([])
				setHasSearched(true)
			} finally {
				if (seq === requestSeq.current) setLoading(false)
			}
		}, DEBOUNCE_MS)

		return () => clearTimeout(timer)
	}, [query])

	const goTo = (violationId) => {
		history.push(`/violation/${violationId}`)
	}

	const handleKeyDown = (e) => {
		if (e.key === 'Enter' && results.length > 0) {
			e.preventDefault()
			goTo(results[0].violation_id)
		}
	}

	return (
		<div className='vo-container'>
			<div className='vo-search-wrap'>
				<input
					className='vo-input'
					type='text'
					placeholder='Search by violation ID, case ID, URL, domain, or organization name…'
					value={query}
					onChange={(e) => setQuery(e.target.value)}
					onKeyDown={handleKeyDown}
					autoFocus
				/>
				{query.trim().length > 0 && query.trim().length < 2 && (
					<div className='vo-hint'>Type at least 2 characters</div>
				)}
			</div>

			{loading && <div className='vo-status'>Searching…</div>}

			{!loading && hasSearched && results.length === 0 && (
				<div className='vo-status'>No matches</div>
			)}

			{!loading && results.length > 0 && (
				<div className='vo-results'>
					<div className='vo-results-header'>
						{results.length} result{results.length === 1 ? '' : 's'}
					</div>
					{results.map((r) => (
						<button
							key={r.violation_id}
							type='button'
							className='vo-result'
							onClick={() => goTo(r.violation_id)}
						>
							<div className='vo-result-top'>
								<span className='vo-result-id'>
									{r.case_id || r.violation_id}
								</span>
								<span
									className={`vo-result-state vo-state-${r.state || 'unknown'}`}
								>
									{r.state || 'unknown'}
								</span>
							</div>
							<div className='vo-result-bottom'>
								{r.organization_name && (
									<span className='vo-result-org'>{r.organization_name}</span>
								)}
								{r.domain && <span className='vo-result-separator'>·</span>}
								{r.domain && (
									<span className='vo-result-domain'>{r.domain}</span>
								)}
							</div>
							{r.url_raw && <div className='vo-result-url'>{r.url_raw}</div>}
						</button>
					))}
				</div>
			)}

			{!hasSearched && !loading && query.trim().length < 2 && (
				<div className='vo-empty'>
					<p>
						Find a violation by ID, case ID, URL, domain, or organization name.
					</p>
				</div>
			)}
		</div>
	)
}

export default withRouter(ViolationOverview)
